import { ChannelDatum, Metric, OnlineStatus, BatteryStatus } from '../../types';
import * as PXBColors from '@brightlayer-ui/colors';

export const getStatusIcon = (value: OnlineStatus): 'CloudQueue' | 'CloudDone' | 'CloudOff' => {
    switch (value) {
        case OnlineStatus.Online:
            return 'CloudDone';
        case OnlineStatus.Pending:
            return 'CloudOff';
        default:
            return 'CloudOff';
    }
};

export const getStatusIconColor = (value: OnlineStatus): string => {
    switch (value) {
        case OnlineStatus.Online:
            return PXBColors.blue[500];
        case OnlineStatus.Offline:
            return PXBColors.red[500];
        default:
            return PXBColors.gray[500];
    }
};

const getMetricIconColor = (channelName: string): string => {
    switch (channelName) {
        case 'Battery':
            return PXBColors.blue[500];
        case 'Humidity':
            return PXBColors.blue[200];
        default:
            return PXBColors.black[500];
    }
};

export const getMetric = (channelDatum: ChannelDatum): Metric => ({
    ...channelDatum,
    icon: channelDatum.iconClass,
    iconColor: getMetricIconColor(channelDatum.channelName),
});

export const getBatteryIconColor = (value: BatteryStatus): string => {
    switch (value) {
        case BatteryStatus.Full:
            return PXBColors.blue[500];
        case BatteryStatus.Alarm:
            return PXBColors.red[500];
        default:
            return PXBColors.gray[500];
    }
};
